(function () {
    'use strict';

    angular
        .module('franchisee-portal.constants')
        .constant('LOCAL_STORAGE_ITEMS', {
            ACCESS_TOKEN: 'LavpopSSOAccessToken',
            ACCESS_TOKEN_REFRESH: 'LavpopSSORefreshAccessToken',
            ACCESS_TOKEN_EXPIRATION: 'LavpopSSOAccessTokenExpiration',
            ACCESS_TOKEN_OWNER: 'LavpopSSOAccessTokenOwner'
        })
        .constant('AUTH_EVENTS', {
            NOT_AUTHENTICATED: 'auth-not-authenticated'
        })
        .constant('DATA_EVENTS', {
            SELECTED_UNIT_CHANGE: 'selected-unit-change'
        })
        .constant('PATHS', {
            PHYSICAL: '/app/src/angular'
        })
        .constant('ROUTES', {
            CENTRAL_CONTAS: 'https://sso-dev.lavpop.com.br/',
            // APP: 'https://portal-dev.lavpop.com.br',
            APP: 'https://localhost:3000',
            API: 'https://portal-dev.lavpop.com.br/api'
        })
        .constant('KEYS', {
            CLIENT_ID: '5Q2xiyn9K3JqGrs8SIRl9oA2DGMDGDsm'
        })
}());